<template>

  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="loading">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
      <div class="m-2">
        <dump-plan-form
            :on-submit="onSubmit"          
            :work-area-items="form.areas"
            :landfill-area-items="form.landfills"
            :plan-data="form"
            :errors="errors">
        </dump-plan-form>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormInvalidFeedback,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm,BFormGroup, BFormCheckboxGroup
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { onUnmounted,} from '@vue/composition-api'
import store from '@/store'
import PlanListAddNew from '@/views/modules/plans/garden-plan/plans-list/PlanListAddNew'
import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import DumpPlanForm from './share/DumpPlanForm'
import PlanStore from '../functions/plansStore'
import useDumpPlan from './share/useDumpPlan'

export default {
  components: {
    OrbitSpinner,AreaFormRepeater,flatPickr,BFormInvalidFeedback,
    BCard, BRow, BCol, BFormInput, BButton, BTable,BFormCheckboxGroup,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect, PlanListAddNew, BForm, BFormGroup,
    DumpPlanForm
  },
  directives: {
    Ripple,
  },

  setup(props, {root}) {

    if (!store.hasModule('plans'))
      store.registerModule('plans', PlanStore)

    onUnmounted(() => {
      if (store.hasModule('plans'))
        store.unregisterModule('plans')
    })

    const { loading, submit, form, errors, workAreaItems } = useDumpPlan()
      
    const onSubmit = () => {

      submit().then(() => {

        root.$bvToast.toast(root.$t('rain plan added successfully'), {
          title: root.$t("success"),
          variant: 'success',
          solid: false,
        })
      }).catch(reason => {

        root.$bvToast.toast(root.$t(reason), {
          title: root.$t("Error"),
          variant: 'danger',
          solid: false,
        })
      })
    }


    return {
      workAreaItems,
     
      onSubmit,
      loading,
      form,
      errors,
    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 90px;
}
.actionIcon > button {
  padding: 0;
}
</style>
